import React from 'react'
import { TextField, InputAdornment } from '@mui/material'

// Guarda SOLO dígitos crudos (lo que esperan los servlets) y muestra $1.234.567 (es-CO).
const soloDigitos = (s) => String(s ?? '').replace(/[^\d]/g, '')
const conMiles = (s) => {
  const d = soloDigitos(s)
  return d ? Number(d).toLocaleString('es-CO') : ''
}

/**
 * Campo de dinero: value = string de dígitos crudos, onChange(rawString).
 * Reemplaza a <TextField type="number"> para PVP / montos.
 */
const MoneyField = ({ value, onChange, InputProps, ...props }) => (
  <TextField
    // size small por defecto: sin esto el campo queda más alto que los Autocomplete de al lado
    size="small"
    {...props}
    value={conMiles(value)}
    onChange={(e) => onChange(soloDigitos(e.target.value))}
    InputProps={{
      startAdornment: <InputAdornment position="start">$</InputAdornment>,
      inputProps: { inputMode: 'numeric' },
      ...(InputProps || {}),
    }}
  />
)

export default MoneyField
